/* eslint-disable max-classes-per-file */
export default class UserTemplateBuilder {
  constructor(build) {
    this.id = build.id;
    this.name = build.name;
    this.description = build.description;
    this.type = build.type;
    this.queries = build.queries;
  }

  static builder() {
    return new UserTemplateBuilder.Builder();
  }
}

UserTemplateBuilder.Builder = class {
  constructor() {
    this.obj = {};
  }

  id(id) {
    this.obj.id = id;
    return this;
  }

  name(name) {
    this.obj.name = name;
    return this;
  }

  description(description) {
    this.obj.description = description;
    return this;
  }

  type(type) {
    this.obj.type = type;
    return this;
  }

  queries(queries) {
    this.obj.queries = queries;
    return this;
  }

  build() {
    return new UserTemplateBuilder(this.obj);
  }
};
